import { createSlice } from "@reduxjs/toolkit";
import { approvedResourceList, viewResource } from "../actions/resourcesAction";

const scholarshipSlice = createSlice({
  name: "resources",
  initialState: {
    resources: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(approvedResourceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approvedResourceList.fulfilled, (state, action) => {
        state.loading = false;
        state.resources = action.payload;
      })
      .addCase(approvedResourceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.resources = [];
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewResource.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewResource.fulfilled, (state, action) => {
        state.loading = false;
        state.resources = action.payload;
      })
      .addCase(viewResource.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default scholarshipSlice.reducer;
